var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Button } from "../../Button";
import React from 'react';
import { css, mq, styled } from "../../../utils";
import Footer from "./Footer";
var StyledFooter = styled(Footer)(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      button:first-of-type {\n        ", "\n      }\n\n      button {\n        &:not([disabled]) {\n          &:hover {\n            border-color: ", ";\n            color: ", ";\n\n            path {\n              fill: ", ";\n            }\n          }\n        }\n\n        ", ";\n      }\n    "], ["\n      button:first-of-type {\n        ",
        "\n      }\n\n      button {\n        &:not([disabled]) {\n          &:hover {\n            border-color: ", ";\n            color: ", ";\n\n            path {\n              fill: ", ";\n            }\n          }\n        }\n\n        ",
        ";\n      }\n    "])), mq({
        padding: ['0 1rem', '1rem'],
    }), colors.white, colors.white, colors.white, mq({
        width: ['100%', 'auto'],
        height: ['100%', 'auto'],
        padding: ['0 1rem'],
    }));
}, mq({
    justifyContent: ['space-evenly', 'flex-end'],
    padding: ['0', '0 2rem', '0 3rem', '0 4rem'],
}));
var VerticalSep = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 2px;\n    height: 20px;\n    background: ", ";\n  "], ["\n    width: 2px;\n    height: 20px;\n    background: ", ";\n  "])), colors.white);
}, mq({
    display: ['block', 'none'],
}));
var MobileButton = styled(Button)(mq({
    display: ['block', 'none'],
}));
var DesktopButton = styled(Button)(mq({
    display: ['none', 'block'],
}));
var FormFooter = function (_a) {
    var labelCancel = _a.labelCancel, labelSubmit = _a.labelSubmit, onCancel = _a.onCancel, onSubmit = _a.onSubmit, _b = _a.disabledCancel, disabledCancel = _b === void 0 ? false : _b, _c = _a.disabledSubmit, disabledSubmit = _c === void 0 ? false : _c, className = _a.className;
    return (React.createElement(StyledFooter, { "data-component": "FormFooter", className: className },
        React.createElement(Button, { type: "button", ghost: true, disabled: disabledCancel, onClick: onCancel }, labelCancel),
        React.createElement(VerticalSep, null),
        React.createElement(DesktopButton, { type: "button", outline: true, disabled: disabledSubmit, onClick: onSubmit }, labelSubmit),
        React.createElement(MobileButton, { type: "button", ghost: true, disabled: disabledSubmit, onClick: onSubmit }, labelSubmit)));
};
export default FormFooter;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FormFooter.js.map